module.exports = __webpack_public_path__ + "static/media/cropping_06.00488540.png";